// src/components/admin/AdminLayout.js

import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import brasao from '../../assets/brasao.png';

const MENU = [
  { to: '/admin/dashboard',    icon: '📊', label: 'Dashboard' },
  { to: '/admin/informativos', icon: '📋', label: 'Informativos' },
  { to: '/admin/batismo',      icon: '🕊️',  label: 'Batismo' },
  { to: '/admin/noivos',       icon: '💍', label: 'Curso de Noivos' },
  { to: '/admin/solicitacoes', icon: '📜', label: 'Solicitações' },
  { to: '/admin/capelas',      icon: '⛪', label: 'Comunidades' },
  { to: '/admin/dizimo',       icon: '🙏', label: 'Dizimistas' },
  { to: '/admin/conteudo',     icon: '✏️',  label: 'Conteúdo' },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sideOpen, setSideOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  const Sidebar = () => (
    <aside style={{ width: '240px', background: 'var(--navy-dark)', minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'sticky', top: 0, height: '100vh', overflow: 'auto' }}>
      <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <img src={brasao} alt="Brasão" style={{ width: 38, height: 38, objectFit: 'contain', filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.5))', flexShrink: 0 }} />
        <div>
          <div style={{ color: 'var(--white)', fontWeight: 700, fontSize: '0.8rem', lineHeight: 1.2 }}>Painel Admin</div>
          <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.68rem', marginTop: '0.1rem' }}>N. Sra. da Conceição</div>
        </div>
      </div>
      <nav style={{ flex: 1, padding: '1rem 0' }}>
        {MENU.map(({ to, icon, label }) => (
          <NavLink key={to} to={to} style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: '0.75rem',
            padding: '0.75rem 1.5rem',
            color: isActive ? 'var(--gold)' : 'rgba(255,255,255,0.65)',
            textDecoration: 'none', fontSize: '0.875rem',
            background: isActive ? 'rgba(201,160,48,0.1)' : 'transparent',
            borderLeft: isActive ? '3px solid var(--gold)' : '3px solid transparent',
            transition: 'all 0.15s',
          })}>
            <span style={{ fontSize: '1rem' }}>{icon}</span>{label}
          </NavLink>
        ))}
      </nav>
      <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.75rem', marginBottom: '0.75rem' }}>
          Olá, <strong style={{ color: 'var(--gold)' }}>{user?.nome || user?.usuario}</strong>
        </div>
        <button onClick={handleLogout} style={{ width: '100%', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)', padding: '0.5rem 1rem', borderRadius: 'var(--radius-sm)', cursor: 'pointer', fontSize: '0.8rem', transition: 'all 0.15s' }}
          onMouseEnter={e => { e.target.style.background = 'rgba(201,160,48,0.15)'; e.target.style.color = 'var(--gold)'; }}
          onMouseLeave={e => { e.target.style.background = 'rgba(255,255,255,0.06)'; e.target.style.color = 'rgba(255,255,255,0.6)'; }}>
          Sair
        </button>
        <div style={{ marginTop: '0.75rem' }}>
          <a href="/" style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.75rem', textDecoration: 'none' }}>← Ver site público</a>
        </div>
      </div>
    </aside>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--off-white)' }}>
      <div className="hide-mobile"><Sidebar /></div>
      <button className="hide-desktop" onClick={() => setSideOpen(o => !o)} style={{ position: 'fixed', top: '1rem', left: '1rem', zIndex: 1100, background: 'var(--navy)', border: 'none', color: 'var(--white)', width: 40, height: 40, borderRadius: 'var(--radius-sm)', fontSize: '1.25rem', cursor: 'pointer' }}>
        {sideOpen ? '✕' : '☰'}
      </button>
      {sideOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1050, display: 'flex' }} onClick={e => { if (e.target === e.currentTarget) setSideOpen(false); }}>
          <div style={{ background: 'rgba(0,0,0,0.5)', flex: 1 }} />
          <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0 }} onClick={() => setSideOpen(false)}><Sidebar /></div>
        </div>
      )}
      <main style={{ flex: 1, overflow: 'auto' }}><Outlet /></main>
    </div>
  );
};

export default AdminLayout;